module.exports = __webpack_public_path__ + "static/img/favicon.81ffb828.svg";